( function( $ ) {
	'use strict';

	$( function() {
		const $carousel = $( '.js-content-carousel' );
		const dotsContainerSelector = '.js-content-carousel-dots';
		const $counter = $( '.js-content-carousel-counter' );

		$carousel.on( 'changed.owl.carousel', function( event ) {
			let carousel = event.relatedTarget;
			$counter.text( `${carousel.relative(carousel.current()) + 1} / ${carousel.items().length}` );
		} );

		const updateLink = ( index ) => {
			let $sourceButtons = $( '.js-content-carousel-link-source' );
			let $targetButton = $( '.js-content-carousel-link-target' );

			if ( index < 0 ) {
				index = 0;
			}

			$targetButton.attr( 'href', $sourceButtons[index] );

			if ( '#' !== $targetButton.attr( 'href' ) ) {
				$targetButton.addClass( 'is-visible' );
			}
		};

		$carousel.on( 'initialize.owl.carousel, changed.owl.carousel', function( event ) {
			updateLink( event.page.index );
		} );

		$carousel.owlCarousel( {
			items: 1,
			dots: true,
			dotsContainer: dotsContainerSelector
		} );

	} );
} )( jQuery );
